// Catch-all view for paths that don't match a known route.

import { el } from './dom';

export function renderNotFoundView(root: HTMLElement): void {
  root.append(
    el('div', { class: 'view-error' },
      el('h2', { class: 'view-error-title' }, '404 — Seite nicht gefunden'),
      el(
        'p',
        { class: 'view-error-body' },
        'Diese URL kennt Slot nicht. Vielleicht ist der Link ungültig?',
      ),
      el('a', { class: 'view-error-link', href: '/' }, '← Zurück zur Startseite'),
    ),
  );
}
